/* @flow */

import { combineReducers } from 'redux';
import { Map } from 'immutable';

const items = (state = Map(), action) => {
  switch (action.type) {
    case 'FETCH_FOLDERS_SUCCESS':
      return Map(action.response.entities.resources);
    case 'UPLOAD_FILE_SUCCESS':
      return state.set(action.response.id, action.response);
    case 'UPDATE_RESOURCE':
      return state.set(action.resource.id, action.resource);
    case 'REMOVE_FOLDER_SUCCESS':
      return state.filter(
        r => r.folderId.toString() !== action.folderId.toString()
      );
    case 'REMOVE_RESOURCE_SUCCESS':
      return state.remove(action.resourceId);
    default:
      return state;
  }
};

const filter = (state = '', action) => {
  switch (action.type) {
    case 'FILTER_RESOURCES':
      return action.value;
    default:
      return state;
  }
};

const isRemoving = (state: boolean = false, action: Action) => {
  switch (action.type) {
    case 'REMOVE_RESOURCE':
      return true;
    case 'REMOVE_RESOURCE_SUCCESS':
      return false;
    default:
      return state;
  }
};

export default combineReducers({
  items,
  filter,
  isRemoving,
});

const getFilter = state => state.resources.filter;

export const getCountByFolder = state =>
  state.resources.items.groupBy(r => r.folderId).map((rs, _) => rs.size);

export const getResourcesByFolder = (state, folderId) => {
  const filter = getFilter(state);

  const resources = state.resources.items
    .filter(r => r.folderId.toString() === folderId.toString())
    .toList();

  // Apply filtering
  return filter && filter.length
    ? resources.filter(
        r => r.name.toLowerCase().indexOf(filter.toLowerCase()) > -1
      )
    : resources;
};

export const getIsRemoving = (state: State): boolean =>
  state.resources.isRemoving;



// WEBPACK FOOTER //
// ./src/modules/bucket/reducers/resources.js